import { Suspense, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../AppContext";
import { getToken } from "../utils/tokenStorage";
import { setStudentRedirectUrl } from "../utils/redirectStorage";
import Loader from "./Loader";

const PrivateRoute = ({ Component, ...rest }) => {
  const { state } = useAppContext();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 990);
    };

    handleResize(); // Set initial value

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const checkAuthStatus = async () => {
      setIsLoading(true);
      try {
        const token = await getToken();
        const isAuthenticated = token !== null;

        setIsAuthenticated(isAuthenticated);

        if (!isAuthenticated) {
          // Store current URL for student routes before redirecting to login
          const currentPath = location.pathname + location.search;
          const redirectValue = currentPath.startsWith("/")
            ? currentPath.slice(1)
            : currentPath;
          navigate(`/login?redirect=${encodeURIComponent(redirectValue)}`, {
            replace: true,
          });
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        // Store current URL for student routes before redirecting to login on error
        const currentPath = location.pathname + location.search;
        setStudentRedirectUrl(currentPath);
        const redirectValue = currentPath.startsWith("/")
          ? currentPath.slice(1)
          : currentPath;
        navigate(`/login?redirect=${encodeURIComponent(redirectValue)}`, {
          replace: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, [state.isLoggedIn, navigate, location]);

  if (isLoading) {
    return <Loader />;
  }

  return isAuthenticated ? (
    <Suspense fallback={<Loader />}>
      <Component isMobileView={isMobileView} {...rest} />
    </Suspense>
  ) : (
    <Loader />
  );
};

export default PrivateRoute;
